import { render } from "./GuardView.vue?vue&type=template&id=1e8352ab"
import script from "./GuardView.vue?vue&type=script&lang=js"
export * from "./GuardView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myproject\\my\\dp2\\frontend\\public-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__